import moment from 'moment';
import classNames from 'classnames';
import widgetLanguages from '../pages/Widget/constants/widgetLanguages';
import formatPhoneForDisplay from '../helpers/formatPhoneForDisplay';

class WidgetsServices {
  static sortedWidgetLanguages = (selected, allowedLanguages) => {
    const filteredLanguages = Object.values(widgetLanguages).filter((i) => i.code !== selected.code && allowedLanguages.includes(i.code));
    return [selected, ...filteredLanguages];
  };

  static isValidAndFutureOrToday = (dateString) => {
    const format = 'YYYY-MM-DD';
    const today = moment().startOf('day');

    const isValidFormat = moment(dateString, format, true).isValid();

    if (!isValidFormat) {
      return false;
    }

    const inputDate = moment(dateString, format);
    return inputDate.isSameOrAfter(today);
  };

  static convertPhoneNumber = (phoneNumber, phonePrefixed) => formatPhoneForDisplay(phoneNumber, phonePrefixed);

  static checkIfColorIsValid = (color) => {
    const hexColorRegex = /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/;
    return hexColorRegex.test(color);
  };

  static shouldShowManagerPhoneComponent = ({
    widgetData, widgetParams, styles, widgetDefaults, message = '',
  }) => {
    const isMessageForNumber = ['телефон', 'связаться'].some((i) => message.toLowerCase().includes(i.toLowerCase()));
    if (isMessageForNumber || (typeof widgetData.max_guests === 'number' && widgetData.max_guests < widgetParams.persons)) {
      return (
        <>
          {': '}
          <a
            href={`tel:${widgetDefaults.managerPhone}`}
            className={classNames(styles.phoneNumber, styles.clickableOpacity)}
          >
            {widgetDefaults.managerPhone}
          </a>
        </>
      );
    }
    return null;
  };
}

export default WidgetsServices;
